import React, { createContext } from "react";
import moment from "../../Moment";

import { PassageForm as PassageFormInterface } from "../../interfaces/passage";

export const PassageForm = createContext<PassageFormInterface>({
  arrival_location_id: "0",
  departure_location_id: "0",
  date: moment().format("YYYY-MM-DD"),
  hour: "",
  minutes: "",
  observation: "",
  car_id: ""
});

const injectContext = <P extends Object>(
  Component: React.ComponentType<P & PassageFormInterface>
): React.FC<P> => props => (
  <PassageForm.Consumer>
    {value => <Component {...value} {...props} />}
  </PassageForm.Consumer>
);

export default injectContext;
